import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["container", "template", "row", "rowNumber", "addButton", "amenityInput", "amenityCount", "removeButton", "removeLabel", "removeIcon", "dragHandle"]

  static values = {
    maxRows: { type: Number, default: 10 }
  }

  connect() {
    this.idSequence = 0
    if (this.rowTargets.length === 0) this.addRowFromTemplate()
    this.assignRowElementIds()
    this.updateAddButtonState()
    this.sortable = Sortable.create(this.containerTarget, {
      handle: ".sortable-handle",
      animation: 150,
      ghostClass: "opacity-50",
      onEnd: () => this.assignRowElementIds(),
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  add(event) {
    event.preventDefault()
    if (this.rowTargets.length >= this.maxRowsValue) return

    this.addRowFromTemplate()
    this.assignRowElementIds()
    this.updateAddButtonState()
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest("[data-amenities-form-target='row']")
    if (!row) return

    row.remove()
    if (this.rowTargets.length === 0) this.addRowFromTemplate()
    this.assignRowElementIds()
    this.updateAddButtonState()
  }

  addRowFromTemplate() {
    const fragment = this.templateTarget.content.cloneNode(true)
    this.containerTarget.appendChild(fragment)
  }

  assignRowElementIds() {
    this.rowTargets.forEach((row, index) => {
      if (!row.dataset.rowToken) {
        row.dataset.rowToken = this.generateRowToken()
      }

      const token = row.dataset.rowToken
      row.id = `thing-amenity-row-${token}`
      if (this.rowNumberTargets[index]) {
        this.rowNumberTargets[index].id = `thing-amenity-row-number-${token}`
        this.rowNumberTargets[index].textContent = String(index + 1)
      }

      if (this.amenityInputTargets[index]) this.amenityInputTargets[index].id = `thing-amenity-input-${token}`
      if (this.amenityCountTargets[index]) this.amenityCountTargets[index].id = `thing-amenity-count-${token}`
      if (this.removeButtonTargets[index]) this.removeButtonTargets[index].id = `thing-amenity-remove-button-${token}`
      if (this.removeLabelTargets[index]) this.removeLabelTargets[index].id = `thing-amenity-remove-button-label-${token}`
      if (this.removeIconTargets[index]) this.removeIconTargets[index].id = `thing-amenity-remove-button-icon-${token}`
      if (this.dragHandleTargets[index]) this.dragHandleTargets[index].id = `thing-amenity-drag-handle-${token}`
    })
  }

  generateRowToken() {
    this.idSequence += 1
    const randomFiveDigits = Math.floor(Math.random() * 90000) + 10000
    const sequenceThreeDigits = String(this.idSequence % 1000).padStart(3, "0")
    return `${Date.now()}${randomFiveDigits}${sequenceThreeDigits}`
  }

  updateAddButtonState() {
    if (!this.hasAddButtonTarget) return

    const atLimit = this.rowTargets.length >= this.maxRowsValue
    this.addButtonTarget.disabled = atLimit
    this.addButtonTarget.classList.toggle("opacity-50", atLimit)
    this.addButtonTarget.classList.toggle("cursor-not-allowed", atLimit)
  }
}
